'use strict';

// =====================================================
//  * Table of content - Academy: Page
// -----------------------------------------------------
// ======================================================

// ====================
// 1. Select
// ====================
var selectInner = document.querySelector('.select-filters');
var select = document.querySelector('.select-filters select');
selectInner.setAttribute('data-count', select.selectedOptions[0].getAttribute('data-count'));

select.addEventListener('change', function (e) {
	selectInner.setAttribute('data-count', select.selectedOptions[0].getAttribute('data-count'));
    document.location.href = e.target.selectedOptions[0].getAttribute('data-link');
});